<vc-dialog
    [loading]="loading"
    [visible]="visible"
    [title]="dialogTitle"
    [primaryLabel]="primaryButtonText"
    [secondaryLabel]="'COMMON_UI.CANCEL' | transloco"
    [width]="'500px'"
    [closeOnPrimary]="false"
    [showSecondary]="showSecondaryTrigger"
    [showCloseIcon]="showCloseIcon"
    [actionsOnLeft]="false"
    (visibleChange)="visibleChange.emit($event)"
    (primaryTrigger)="nextStep()"
    (secondaryTrigger)="cancelMfa.emit()">
    @if (currentStep === mfaStep.INTRO) {
        <div class="body-medium">{{ 'ACCOUNT.ENABLE_MFA_DESCRIPTION' | transloco }}</div>
    }
    @if (currentStep === mfaStep.QRCODE) {
        <div class="body-medium">
            <qrcode
                style="display: flex; justify-content: center; height: 200px"
                [allowEmptyString]="true"
                [qrdata]="qrData"
                [width]="200"
                [errorCorrectionLevel]="'M'"
                [vcProgressSpinner]="!qrData"></qrcode>
            <span>{{ 'ACCOUNT.ENABLE_MFA_PLEASE_SCAN' | transloco }}</span>
        </div>
    }
    @if (currentStep === mfaStep.VERIFY) {
        <div class="vc-flex-column gap-24 body-medium">
            <vc-input
                class="space-top-4"
                [label]="'ACCOUNT.ENABLE_MFA_VERIFICATION_CODE' | transloco"
                [(value)]="verificationCode"
                [required]="true"></vc-input>
            <span>Please enter the current authenticator code and click next.</span>
        </div>
    }
    @if (currentStep === mfaStep.END) {
        <div class="body-medium">
            <span>{{ 'ACCOUNT.ENABLE_MFA_COMPLETED' | transloco }}</span>
        </div>
    }
</vc-dialog>
